export const Main = r => require.ensure([], () => r(require('../../Core/components/Main')), 'Financial-bundle')
export const ListPaymentAdjust = r => require.ensure([], () => r(require('../../Financial/components/PaymentAdjust/ListPaymentAdjust')), 'Financial-bundle')
export const EditNewPaymentAdjust = r => require.ensure([], () => r(require('../../Financial/components/PaymentAdjust/EditNewPaymentAdjust')), 'Financial-bundle')
export const ListDeposits = r => require.ensure([], () => r(require('../components/Deposits/ListDeposits.vue')), 'Financial-bundle')
export const ListBenefiers = r => require.ensure([], () => r(require('../components/Deposits/BenefiersEC/ListBenefiers.vue')), 'Financial-bundle')
export const AddOrEditBenefier = r => require.ensure([], () => r(require('../components/Deposits/BenefiersEC/AddOrEditBenefier.vue')), 'Financial-bundle')
export const ListPaymentSplit = r => require.ensure([], () => r(require('../components/Deposits/PaymentSplit/ListPaymentSplit.vue')), 'Financial-bundle')
export const AddOrEditSplit = r => require.ensure([], () => r(require('../components/Deposits/PaymentSplit/AddOrEditSplit.vue')), 'Financial-bundle')
export const ListPaymentSplitMkt = r => require.ensure([], () => r(require('../components/Deposits/PaymentSplitMarketplace/ListPaymentSplit.vue')), 'Financial-bundle')
export const AddOrEditSplitMkt = r => require.ensure([], () => r(require('../components/Deposits/PaymentSplitMarketplace/AddOrEditSplit.vue')), 'Financial-bundle')
export const PaymentBankSlip = r => require.ensure([], () => r(require('../components/Deposits/PaymentBankSlip/ListPaymentBankSlip.vue')), 'Financial-bundle')
export const AddOrEditPaymentBankSlip = r => require.ensure([], () => r(require('../components/Deposits/PaymentBankSlip/AddOrEditPaymentBankSlip.vue')), 'Financial-bundle')
export const ListExtract = r => require.ensure([], () => r(require('../components/Extract/ListExtract.vue')), 'Financial-bundle')
export const ReceivablesManagement = r => require.ensure([], () => r(require('../components/Deposits/ReceivablesManagement.vue')), 'Financial-bundle')
export const ListPayment = r => require.ensure([], () => r(require('../components/Payment/ListPayment.vue')), 'Financial-bundle')
export const ViewPayment = r => require.ensure([], () => r(require('../components/Payment/ViewPayment.vue')), 'Financial-bundle')

const children = [
  {
    name: 'financial_management.deposit.index',
    path: 'agenda-financeira',
    component: ListDeposits,
    meta: {
      requiresAuth: true,
      title: 'Agenda Financeira',
      titleMenu: 'Agenda Financeira',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Agenda Financeira',
          pathName: 'financial_management.deposit.index'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.benefiers_ec',
    path: 'beneficiarios-ec',
    component: ListBenefiers,
    meta: {
      requiresAuth: true,
      title: 'Beneficiários do EC',
      titleMenu: 'Beneficiários do EC',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Beneficiários do EC',
          pathName: 'financial_management.deposit.benefiers_ec'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.add_benefier_ec',
    path: 'add-beneficiario-ec',
    component: AddOrEditBenefier,
    meta: {
      requiresAuth: true,
      title: 'Adicionar Beneficiário',
      titleMenu: 'Adicionar Beneficiário',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Beneficiários do EC',
          pathName: 'financial_management.deposit.benefiers_ec'
        },
        {
          name: 'Adicionar Beneficiário',
          pathName: 'financial_management.deposit.add_benefier_ec'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.edit_benefier_ec',
    path: 'edit-beneficiario-ec/:id',
    component: AddOrEditBenefier,
    meta: {
      requiresAuth: true,
      title: 'Editar Beneficiário',
      titleMenu: 'Editar Beneficiário',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Beneficiários do EC',
          pathName: 'financial_management.deposit.benefiers_ec'
        },
        {
          name: 'Editar Beneficiário',
          pathName: 'financial_management.deposit.edit_benefier_ec'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.payment_split',
    path: 'pagamento-split',
    component: ListPaymentSplit,
    meta: {
      requiresAuth: true,
      title: 'Split de Recebíveis',
      titleMenu: 'Split de Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Split de Recebíveis',
          pathName: 'financial_management.deposit.payment_split'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.add_payment_split',
    path: 'add-pagamento-split',
    component: AddOrEditSplit,
    meta: {
      requiresAuth: true,
      title: 'Split de Recebíveis',
      titleMenu: 'Split de Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Split de Recebíveis',
          pathName: 'financial_management.deposit.payment_split'
        },
        {
          name: 'Adicionar Split',
          pathName: 'financial_management.deposit.add_payment_split'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.edit_payment_split',
    path: 'edit-pagamento-split/:id',
    component: AddOrEditSplit,
    meta: {
      requiresAuth: true,
      title: 'Editar Split de Recebíveis',
      titleMenu: 'Editar Split de Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Split de Recebíveis',
          pathName: 'financial_management.deposit.payment_split'
        },
        {
          name: 'Editar Split',
          pathName: 'financial_management.deposit.edit_payment_split'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.split_marketplace',
    path: 'split-marketplace',
    component: ListPaymentSplitMkt,
    meta: {
      requiresAuth: true,
      title: 'Split de Marketplace',
      titleMenu: 'Split de Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Split do Marketplace',
          pathName: 'financial_management.deposit.split_marketplace'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.add_split_marketplace',
    path: 'add-split-marketplace',
    component: AddOrEditSplitMkt,
    meta: {
      requiresAuth: true,
      title: 'Split de Marketplace',
      titleMenu: 'Split de Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Split de Marketplace',
          pathName: 'financial_management.deposit.split_marketplace'
        },
        {
          name: 'Adicionar Split',
          pathName: 'financial_management.deposit.add_split_marketplace'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.edit_split_marketplace',
    path: 'edit-split-marketplace/:id',
    component: AddOrEditSplitMkt,
    meta: {
      requiresAuth: true,
      title: 'Editar Split de Marketplace',
      titleMenu: 'Editar Split de Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Split de Marketplace',
          pathName: 'financial_management.deposit.split_marketplace'
        },
        {
          name: 'Editar Split',
          pathName: 'financial_management.deposit.edit_split_marketplace'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.edit_split_config_marketplace',
    path: 'edit-split-marketplace/:id',
    component: AddOrEditSplitMkt,
    meta: {
      requiresAuth: true,
      title: 'Editar Split de Marketplace',
      titleMenu: 'Editar Split de Marketplace',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Split de Marketplace',
          pathName: 'financial_management.deposit.split_marketplace'
        },
        {
          name: 'Editar Split',
          pathName: 'financial_management.deposit.edit_split_config_marketplace'
        },
      ]
    }
  },
  {
    name: 'financial_management.paymentAdjust.index',
    path: 'ajuste-financeiro',
    component: ListPaymentAdjust,
    meta: {
      requiresAuth: true,
      title: 'Lançamentos Financeiros',
      titleMenu: 'Lançamentos Financeiros',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lançamentos financeiros',
          pathName: 'financial_management.paymentAdjust.index'
        },
      ]
    }
  },
  {
    name: 'financial_management.paymentAdjust.view',
    path: 'ajuste-financeiro/:id',
    component: EditNewPaymentAdjust,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Lançamentos Financeiros',
      titleMenu: 'Pagamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Lançamentos Financeiros',
          pathName: 'financial_management.paymentAdjust.index'
        },
        {
          name: 'Editando Lançamento Financeiro',
          pathName: 'financial_management.paymentAdjust.view'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.payment_bank_slip',
    path: 'payment_bank_slip',
    component: PaymentBankSlip,
    meta: {
      requiresAuth: true,
      title: 'Pagamento via Boleto',
      titleMenu: 'Pagamento via Boleto',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Pagamento via Boleto',
          pathName: 'financial_management.deposit.payment_bank_slip'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.add_payment_bank_slip',
    path: 'add_payment_bank_slip',
    component: AddOrEditPaymentBankSlip,
    meta: {
      requiresAuth: true,
      title: 'Adicionar Pagamento via Boleto',
      titleMenu: 'Adicionar Pagamento via Boleto',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Pagamento via Boleto',
          pathName: 'financial_management.deposit.payment_bank_slip'
        },
        {
          name: 'Adicionar Pagamento via Boleto',
          pathName: 'financial_management.deposit.add_payment_bank_slip'
        },
      ]
    }
  },
  {
    name: 'financial_management.deposit.edit_payment_bank_slip',
    path: 'edit_payment_bank_slip/:id',
    component: AddOrEditPaymentBankSlip,
    meta: {
      requiresAuth: true,
      title: 'Editar Pagamento via Boleto',
      titleMenu: 'Editar Pagamento via Boleto',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Pagamento via Boleto',
          pathName: 'financial_management.deposit.edit_payment_bank_slip'
        },
        {
          name: 'Editar Pagamento via Boleto',
          pathName: 'financial_management.deposit.edit_payment_bank_slip'
        },
      ]
    }
  },
  {
    name: 'financial_management.extract.index',
    path: 'extract',
    component: ListExtract,
    meta: {
      requiresAuth: true,
      title: 'Listando Extrato',
      titleMenu: 'Extrato Financeiro',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Extrato Financeiro',
          pathName: 'financial_management.extract.index'
        }
      ]
    }
  },
  {
    name: 'financial_management.deposit.receivables_management',
    path: 'receivables-management',
    component: ReceivablesManagement,
    meta: {
      requiresAuth: true,
      title: 'Movimentação de Recebíveis',
      titleMenu: 'Movimentação de Recebíveis',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Movimentação de Recebíveis',
          pathName: 'financial_management.deposit.receivables_management'
        }
      ]
    }
  },
  {
    name: 'financial_management.payment.index',
    path: 'pagamentos',
    component: ListPayment,
    meta: {
      requiresAuth: true,
      title: 'Listagem de Pagamentos',
      titleMenu: 'Pagamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Pagamentos',
          pathName: 'financial_management.payment.index'
        },
      ]
    }
  },
  {
    name: 'financial.payment.view',
    path: 'pagamentos/:id',
    component: ViewPayment,
    meta: {
      requiresAuth: true,
      title: 'Visualizando Pagamento',
      titleMenu: 'Pagamentos',
      permission: 'owner|public',
      breadcrumbs: [
        {
          name: 'Pagamentos',
          pathName: 'financial.payment.index'
        },
        {
          name: 'Visualizando Pagamento',
          pathName: 'financial.payment.view'
        },
      ]
    }
  },
]

export default [{
  name: 'financial_management',
  children,
  path: '/gestao-financeira',
  component: Main,
  redirect: { name: 'home.index' },
  meta: {
    requiresAuth: true,
  }
}]
